import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio"];
import React from 'react';

var Channels = function Channels(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: preserveAspectRatio
  }, unhandledProps, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.87,14.5a2.4,2.4,0,1,0-2.23-3.25H3V13H16.65A2.41,2.41,0,0,0,18.87,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,18.92a2.39,2.39,0,0,0-2.66-.07l-3-2.2H3.11v1.77H13.36l2.54,1.85a2.39,2.39,0,0,0,.89,2.53h0a2.38,2.38,0,0,0,2.77-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21,5a2.39,2.39,0,0,0,2.68-.28h0a2.39,2.39,0,1,0-3.83-1.06L13.32,6H3.11V7.79H14Z"
  }))));
};

Channels.displayName = 'Channels';
export default Channels;